/** Re-export canonical shell so standalone routes share one AppShell / Sidebar. */
export { AppShell, Sidebar, TopBar as Topbar, CommandPalette } from '../shell';
